import { useMemo } from 'react'
import { useCheckPolicies } from '../api/policy'

export default function useCheckPolicy (policyName) {
  const { data: policies, isLoading } = useCheckPolicies()

  return useMemo(() => {
    if (isLoading) return false
    return Boolean(policies[policyName])
  }, [policyName, policies, isLoading])
}
